import React, {PropsWithChildren, useCallback, useState} from 'react';
import {TouchableOpacity, View, StyleProp, ViewStyle} from 'react-native';
import {Hr} from '../../../../../shared/components/hr';
import {useTheme} from '../../../../../shared/theme';
import {useCollapseStyles} from './Collapse.style';

interface CollapseProps {
  header: React.ReactNode;
  bodyStyle?: StyleProp<ViewStyle>;
  headerStyle?: StyleProp<ViewStyle>;
  style?: StyleProp<ViewStyle>;
}

export function Collapse({header, children, headerStyle, bodyStyle, style}: PropsWithChildren<CollapseProps>) {
  const [isExpanded, setExpanded] = useState(false);
  const theme = useTheme();

  const handleCollapsePress = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  const styles = useCollapseStyles();

  return (
    <View style={[styles.historyItem, style]}>
      <TouchableOpacity onPress={handleCollapsePress} activeOpacity={1} style={{width: '100%'}}>
        <View style={[styles.collapseHeader, headerStyle]}>{header}</View>
      </TouchableOpacity>

      <View style={[styles.collapseBody, bodyStyle, {display: isExpanded ? 'flex' : 'none'}]}>
        <Hr marginTop={0} marginBottom={0} color={theme.color.borderColor} />
        {children}
      </View>
    </View>
  );
}
